<template>
  <header class="uk-section-muted" _uk-sticky="media: @m">
    <div class="uk-container">
      <nav class="uk-navbar-container" uk-navbar>
        <div class="uk-navbar-left">
          <div class="uk-navbar-item uk-small uk-grid-small _uk-visible@m">
            <router-link :to="{ path: '/' }">
              <img class="uk-logo" :src="require(`@/assets/vectors/logos/${opco.logo}`)" :alt="opco.name" />
            </router-link>
            <h2 class="uk-navbar-item uk-visible@s">{{ $t('app_title') }}</h2>
          </div>
        </div>
        <div class="uk-navbar-right">
          <ul class="uk-navbar-nav uk-visible@m">
            <li v-for="(item, key) in menu" :key="key">
              <router-link :to="{ name: `${item}` }" class="uk-button-text">{{ $t(`route.${key}`) }}</router-link>
            </li>
          </ul>
          <ul class="uk-navbar-nav">
            <li>
              <a :href="userIsGuest ? '#logon-modal' : '#account-modal'" uk-toggle><span uk-icon="user"></span><span class="uk-margin-small-left uk-visible@m">{{ userName }}</span></a>
              <div class="uk-navbar-dropdown uk-dropdown" uk-dropdown="animation: uk-animation-slide-top-small; offset: 0">
                <ul class="uk-nav uk-navbar-dropdown-nav">
                  <li v-if="userIsGuest"><a href="#logon-modal" uk-toggle>{{ $t('user.login.menu') }}</a></li>
                  <li><a href="#account-modal" uk-toggle>
                    <span v-if="userIsGuest">{{ $t('user.account.create.menu') }}</span>
                    <span v-else>{{ $t('user.account.profile.menu') }}</span>
                  </a></li>
                  <li v-if="!userIsGuest"><a href="javascript:;" @click="userLogout">{{ $t('user.logout.menu') }}</a></li>
                </ul>
              </div>
            </li>
          </ul>
          <ul class="uk-navbar-nav uk-visible@m">
            <li>
              <a href="javascript:;">{{ lang }}</a>
              <div class="uk-navbar-dropdown uk-dropdown language" uk-dropdown="animation: uk-animation-slide-top-small; offset: 0">
                <ul class="uk-nav uk-navbar-dropdown-nav">
                  <li v-for="(language, code) in languages" :key="code" :class="{'uk-active': code == lang}">
                    <a :href="'/' + code" @click.prevent="changeLanguage(code)">
                      {{ code }}
                    </a>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
          <a class="uk-navbar-toggle uk-hidden@m uk-navbar-toggle-icon uk-icon" href="#offcanvas" uk-navbar-toggle-icon uk-toggle></a>
        </div>
      </nav>
    </div>
    <userLogonResetModal />
    <userAccountModal />
    <guestVsUserModal />
  </header>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import userLogonResetModal from '../Form/userLogonReset'
import userAccountModal from '../Form/userAccount'
import guestVsUserModal from './guestVsUserModal'

export default {
  components: {
    userLogonResetModal,
    userAccountModal,
    guestVsUserModal
  },

  computed: {
    ...mapState([
      'menu',
      'languages',
      'user'
    ]),

    ...mapGetters([
      'userIsGuest',
      // 'isEverythingSaved',
      'opco',
      'project'
    ]),

    lang () {
      return this.$root.$i18n.locale
    },

    userName () {
      return this.userIsGuest ? this.$t('user.login.guest') : this.user.first_name
    }
  },

  // MOVED into App.vue (more general stuff)
  // as in here we need only userLogout which now also does sync directly on store action
  /* mounted () {
    // We also will call this on visibilitychange instead of on unload as proposed here https://w3c.github.io/beacon/#h-note, especially for mobile when the browser will go into background and then closed by OS
    document.addEventListener('visibilitychange', (event) => {
      if (document.visibilityState === 'hidden') {
        this.sync()
      }
    })

    window.addEventListener('beforeunload', (event) => {
      if (!this.isEverythingSaved) {
        this.sync().then(() => {
          uikit.notification(this.$t('can_close_window'), {pos: 'bottom-right', status: 'success'})
        })

        event.returnValue = this.$t('confirm_window_close')
      }
    })
  }, */

  methods: {
    ...mapActions([
      // 'sync',
      'userLogout'
    ]),

    changeLanguage (lang) {
      this.$emit('changeLanguage', lang)
    }

    // I don't know why using mapActions was raising an error after first use
    // ayway, we need first to check / warn about unsaved projects & slabs
    /* userLogout () {
      // first send a beacon to save
      // MOVED into userLogout() action
      // this.sync()

      this.$store.dispatch('userLogout')
    } */

    /* sync (event = null) {
      let result = true

      // ONLY if user authenticated
      if (!this.userIsGuest) {
        const _this = this

        const data = {
          projects: this.$store.getters['db/projects/query']()
            .where('savedOnServer', false)
            .with('contacts')
            .get()
            .map(project => project.prepareSend), // remove blank contacts

          slabs: this.$store.getters['db/slabs/query']()
            .where('savedOnServer', false)
            .with('loads')
            .with('openings')
            .get()
        }

        if (data.projects.length + data.slabs.length > 0) {
          result = false

          // we can use the modern Fetch() API, but it's not so much different than old AJAX
          const path = data.projects.length ? 'project' : 'slab'

          uikit.util.ajax(`api/${path}`, {
            method: 'post',
            data: JSON.stringify({
              customMethod: 'sync',
              ...data
            }),
            responseType: 'json',
            headers: {
              'Content-Type': 'application/json; charset=UTF-8',
              'X-Requested-With': 'XMLHttpRequest'
            }
          }).then(xhr => {
            // update data if still user logged on
            if (xhr.response.success && !_this.userIsGuest) {
              ['projects', 'slabs'].forEach(type => {
                if (xhr.response[type] && xhr.response[type].length) {
                  xhr.response[type].forEach(record => {
                    if (record.id && record.date_last_save) {
                      _this.$store.dispatch(`db/${type}/update`, {
                        where: record.id,
                        data: {
                          savedOnServer: true,
                          date_last_save: record.date_last_save
                        }
                      })
                    }
                  })
                }
              })

              if (event.type === 'beforeunload') {
                uikit.notification(_this.$t('can_close_window'), {pos: 'bottom-right', status: 'success'})
              }
            }
          })
        }
      }

      return result
    } */
  }
}
</script>

<style scoped>
  .uk-navbar .uk-logo {
    height: 60px;
  }

  h2 {
    font-size: 2rem;
    margin: 0;
  }

  @media (max-width: 639px) {
    h2 {
      font-size: 1.4rem;
    }
  }

  .uk-active .uk-button-text::before,
  .uk-button-text.uk-active::before {
    right: 0;
  }

  .uk-navbar-dropdown {
    padding: 15px;
    min-width: 150px;
    width: auto;
    left: auto !important;
    right: 0;
  }

  .language.uk-navbar-dropdown {
    min-width: 50px;
    text-transform: uppercase;
  }
</style>



// WEBPACK FOOTER //
// src/components/_layout/Header.vue